import { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { urlAppendParam } from 'utils/tabsHeaderUtils';

export default function TabsHeader({
  options,
  param = 'tab',
  variant = 'secondary',
  borderRadius = '8px',
}) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const rawParam = searchParams.get(param);

  const normalizedOptions = options?.map((item) => ({
    option: item.option,
    normalized: item.option?.toLowerCase(),
  }));
  const activeOption =
    normalizedOptions?.find((item) => item.normalized === rawParam?.toLowerCase()) ||
    normalizedOptions?.[0];
  const selectedTab = activeOption?.normalized || '';

  useEffect(() => {
    if (!activeOption || !rawParam) return;
    if (rawParam === activeOption.option) return;
    navigate(urlAppendParam(param, activeOption.option), { replace: true });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeOption?.option, navigate, param, rawParam]);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center w-100">
      <div
        className={`d-flex align-items-center flex-column flex-lg-row w-100`}
        style={{
          background: variant === 'primary' ? '#436C9A' : '#325277',
          borderRadius: borderRadius,
        }}
      >
        {options &&
          options.map((item, index) => {
            return (
              <Button
                className="d-flex align-items-center justify-content-center rounded-0 w-100 btn-transparent"
                as={Link}
                key={index}
                to={urlAppendParam(param, item.option)}
                variant={variant}
              >
                <div
                  className="d-flex align-items-center justify-content-center w-100"
                  style={{
                    borderBottom: selectedTab === item.option.toLowerCase() && '#fff solid 3px',
                  }}
                >
                  {item.option}
                </div>
              </Button>
            );
          })}
      </div>
    </div>
  );
}
